export const SET_JOB = 'SET_JOB'

// export const SET_ACCOUNT = 'SET_ACCOUNT'
// export const SET_FINANCE = 'SET_FINANCE'
// export const SET_INCOMING = 'SET_INCOMING'
// export const SET_OUTGOING = 'SET_OUTGOING'

// export const SET_TAB = 'SET_TAB'
// export const SET_TAB_DATA = 'SET_TAB_DATA'
// export const SET_SHEET = 'SET_SHEET'
// export const SET_SHEET_SETTINGS = 'SET_SHEET_SETTINGS'
// export const RESET_SHEET = 'RESET_SHEET'
//
// export const CHANGE_TAB_NAME = 'CHANGE_TAB_NAME'



// WEBPACK FOOTER //
// ./src/core/finance/action-types.js